module.exports = __webpack_public_path__ + "static/media/sykkelhjelm.0bc0ddaf.mp3";